import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';
export const FilterId = iotsUtils.fromList(constants.wholeHouse.bom.search.filterIds);
